import { render, staticRenderFns } from "./searchForm.vue?vue&type=template&id=6873fda6&scoped=true"
import script from "./searchForm.vue?vue&type=script&lang=js"
export * from "./searchForm.vue?vue&type=script&lang=js"
import style0 from "./searchForm.vue?vue&type=style&index=0&id=6873fda6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6873fda6",
  null
  
)

export default component.exports